import i18n from '@/lang/i18n'

export const ASSOCIATION_TYPE = {
    OPERATION: { key: 'operation', translatedName: i18n.tc('configuration.sections.operations', 2) },
    RESPONSIBILITY: { key: 'responsibility', translatedName: i18n.tc('configuration.sections.responsibilities', 2) },
    ROLE: { key: 'role', translatedName: i18n.tc('configuration.sections.roles', 2) }
}
